import React from 'react';
// Images
import SessionsVideo from '../../assets/video/lc1-1080.webm';
// Data
import {
  CompanyName,
  CompanyEmailAddress,
  LocationCity,
  LocationCountry,
  ServiceArea,
} from '../../utils/Constants';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import CallToActionLearnMore from '../cta/CallToActionLearnMore';

function AboutMePageMainContainer() {
  return (
    <main role='main' className='grid gap-y-12 pt-6 pb-12'>
      {/* About Section */}
      <section className='grid w-full'>
        <div className='grid lg:grid-cols-2 gap-x-8 gap-y-8 p-6 lg:container lg:mx-auto'>
          {/* Video / Image */}
          <div className='grid'>
            <video
              src={SessionsVideo}
              className='w-full h-auto object-contain rounded-2xl shadow-lg max-h-[80vh]'
              autoPlay
              muted
              loop
              playsInline
              controls={false}
              aria-label={`${CompanyName} — Neon-Gothic Dominatrix & Fire-Eater performing`}
            />
          </div>

          {/* Text Content */}
          <section className='grid w-full'>
            <article className='grid p-6 text-center gap-6 h-fit'>
              <h2 className='font-titleFont neon_text_heavy_redpink text-4xl md:text-5xl tracking-wider drop-shadow-lg'>
                ABOUT {CompanyName.toUpperCase()}
              </h2>

              <p className='max-w-2xl mx-auto text-base md:text-lg leading-relaxed'>
                Award-winning, multi-nominated, and{' '}
                <strong>
                  based in {LocationCity}, {LocationCountry}
                </strong>{' '}
                — yet rarely contained by borders. I am a{' '}
                <strong>touring dominatrix</strong> whose presence is as coveted
                as it is rare. What I offer are not sessions, but{' '}
                <em>encounters</em>: immersive descents into desire, fear, and
                exquisite surrender.
              </p>

              <p className='max-w-2xl mx-auto text-base md:text-lg leading-relaxed'>
                With years of experience across a vast spectrum of kinks and
                rituals, I specialize in{' '}
                <strong>
                  transforming indulgence into torment, and torment into
                  transcendence
                </strong>
                . If you like it, I’ll torture you with it — until the boundary
                between agony and ecstasy dissolves into something
                unforgettable.
              </p>

              <p className='max-w-2xl mx-auto text-base md:text-lg leading-relaxed'>
                Those fortunate enough to kneel before Me understand:{' '}
                <strong>this is not play — this is metamorphosis.</strong>I
                infiltrate your mind, lick your synapses, and rewire your hunger
                until you no longer recognize yourself — only your need for Me.
              </p>

              <p className='max-w-2xl mx-auto text-base md:text-lg leading-relaxed'>
                Fly Me To You is available for the select few who dare to invite{' '}
                <strong>danger and luxury</strong> into their own domain.
                Whether in {LocationCity}, on tour, or within the sanctum of
                your choosing, I deliver not just domination — but{' '}
                <em>a life-altering experience</em> you will never escape.
              </p>

              <p className='max-w-2xl mx-auto text-base md:text-lg leading-relaxed italic text-white/80'>
                “More than a goddess… I am divinity realized.”
              </p>
            </article>
          </section>
        </div>
      </section>

      <CallToActionLearnMore />
      {/* Contact CTA */}
      <section className='grid text-center gap-4 px-6'>
        <h3 className='font-titleFont text-3xl md:text-4xl neon_text_thin_magenta drop-shadow-lg tracking-wide'>
          CONTACT {CompanyName.toUpperCase()}
        </h3>
        <p className='text-base md:text-lg leading-relaxed max-w-xl mx-auto'>
          Available <strong>{ServiceArea}</strong>. For bookings,
          collaborations, or media inquiries, reach out directly at{' '}
          <a
            href={`mailto:${CompanyEmailAddress}`}
            className='underline hover:text-pink-400 transition-all'
          >
            {CompanyEmailAddress}
          </a>
          .
        </p>
      </section>

      <SocialMediaCtaComponent />
    </main>
  );
}

export default AboutMePageMainContainer;
